import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { OrganizationsService } from '../../service/organization.service';
import { GenericService } from '../service/generic.service';
import { MessageService } from 'primeng/api';

@Component({
	selector: 'cv-generic-default-settings',
	templateUrl: './generic-default-settings.component.html',
	styleUrls: ['./generic-default-settings.component.scss'],
	providers: [MessageService]
})
export class GenericDefaultSettingsComponent implements OnInit, OnDestroy {
	@Input() integrationId: string;
	public label =  'Default Settings';
	public entity = 'default-settings';
	public organizations: Array<any> = [];
	public selectedOrganization: any;
	public data: any;
	private atComponentDestroy = new Subject();
	constructor(
		public messageService: MessageService,
		private organizationsService: OrganizationsService,
		private service: GenericService
	) {
	}

	ngOnInit(): void {
		this.loadData();
	}

	loadData() {
		this.service.setConfiguration(this.integrationId, this.entity);

		this.service
			.getData()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.data = result;

				this.selectedOrganization = {
					id: this.data.defaultClassOrganizationId,
					name: this.data.defaultClassOrganizationName
				};
			});
	}

	/**
	 * On save grid config.
	 */
	onSave(): void {
		this.service.setConfiguration(this.integrationId, this.entity);
		this.service
			.saveData(this.data)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: `${this.label} was updated` });
				},
				error => {
					console.error(error);
				}
			);
	}

	onOrganizationSelect($event: any) {
		this.data = {...this.data, ...{defaultClassOrganizationId: $event.id, defaultClassOrganizationName: $event.name}};
	}

	filterOrganizations($event: any) {
		this.organizationsService
			.getOrganizationsByName($event.query)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.organizations = result;
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
